import { Component } from '@angular/core';
import { ProductSatusService } from './onelog/services/product-status.service';
import { ProductService } from './onelog/services/product.service';
import { SachLoginService } from './onelog/services/sach-login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'Onelog';

  constructor() {}

  ngOnInit() {}
}
